import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { dateFormat } from '../../helpers/datetime_helpers';

interface EntityListItemERTooltipProps {
  errorReports: ErrorReport[];
  schema: EntitySchema;
}

const EntityListItemERTooltip: FC<EntityListItemERTooltipProps> = ({
  errorReports,
  schema,
}) => {
  return (
    <div>
      <p className="text-xl font-semibold">
        <FormattedMessage
          id="entity_list_item.current_error_reports"
          defaultMessage="Current error reports"
        />
      </p>
      {errorReports.map((er) => {
        const schemaProp = schema.definition.propertiesLookup[er.property_key];
        if (!schemaProp) {
          console.warn(
            "Missing schema property for error report popup for key '" +
              er.property_key +
              "'.",
          );
          return null;
        }
        const name = schemaProp.name;
        let groupName = '';
        if (typeof schemaProp.group_id === 'number') {
          const group = schema.definition.groupsLookup[schemaProp.group_id];
          groupName = `${group.name}: `;
        }
        return (
          <div key={er.id} className="mt-4">
            <p className="text-base leading-6 text-yellow-500">
              <span className="text-white">{groupName}</span>
              {name}
            </p>
            <p className="text-sm leading-6">
              {er.meta.created_at.toFormat(dateFormat)}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default EntityListItemERTooltip;
